import React, { Component } from "react";
import { Alert, Button, Card, Form, Icon, Input } from "antd";
import "./LoginScreen.css";

function formatAuthError(errorMessage) {
  if (!errorMessage) return "";
  if (typeof errorMessage === "string") return errorMessage;
  if (errorMessage.errorMessage) return String(errorMessage.errorMessage);
  if (errorMessage.message) return String(errorMessage.message);
  return "Đăng nhập thất bại. Vui lòng thử lại.";
}

class LoginComponent extends Component {
  componentDidMount() {
    this.props.activeMenuItem("");
    this.props.clearTokenId();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.getTokenId(
        "/api/auth-service/auth",
        {
          userName: values.username,
          password: values.password,
          deviceToken: "notoken",
          uuid: "nouuid",
        },
        () => {
          this.props.history.push("/admins");
        }
      );
    });
  };

  render() {
    const { isLoading, errorMessage, form } = this.props;
    const { getFieldDecorator } = form;
    const errText = formatAuthError(errorMessage);

    return (
      <div className="login-shell">
        <div className="login-shell__accent" aria-hidden="true" />
        <div className="login-shell__main">
          <Card className="login-card" bordered={false}>
            <div className="login-card__header">
              <h1 className="login-card__title">Đăng nhập</h1>
            </div>
            {errText ? (
              <Alert
                className="login-card__alert"
                type="error"
                message={errText}
                showIcon
              />
            ) : null}
            <Form className="login-form" onSubmit={this.handleSubmit}>
              <Form.Item>
                {getFieldDecorator("username", {
                  rules: [
                    { required: true, message: "Nhập tên đăng nhập" },
                  ],
                })(
                  <Input
                    size="default"
                    prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
                    placeholder="Tên đăng nhập"
                    autoComplete="username"
                  />
                )}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator("password", {
                  rules: [{ required: true, message: "Nhập mật khẩu" }],
                })(
                  <Input.Password
                    size="default"
                    prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
                    placeholder="Mật khẩu"
                    autoComplete="current-password"
                  />
                )}
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  size="default"
                  className="login-form__submit"
                >
                  Đăng nhập
                </Button>
              </Form.Item>
            </Form>
            <p className="login-card__footer">Open Road · Admin</p>
          </Card>
        </div>
      </div>
    );
  }
}

export default Form.create({ name: "login" })(LoginComponent);
